module.exports = __webpack_public_path__ + "media/images/nurse-discounts-a97a329dee7d2b9c9549282372160806.svg";